<template>
  <NuxtLink
    :to="`/services/${service.slug}`"
    class="group relative block overflow-hidden rounded-3xl bg-card-gradient p-8 shadow-soft transition-all duration-300 hover:-translate-y-1 hover:shadow-soft-lg dark:bg-card-gradient-dark"
  >
    <div class="relative">
      <!-- Service Icon -->
      <div class="mb-5 flex size-12 items-center justify-center rounded-xl bg-gradient-to-r from-accent to-gradient-end">
        <component :is="service.icon" class="size-6 text-white" />
      </div>

      <!-- Service Content -->
      <h3 class="mb-3 text-xl font-bold text-ternary-dark dark:text-ternary-light">
        {{ service.title }}
      </h3>

      <p class="mb-6 text-gray-600 dark:text-gray-400">
        {{ service.description }}
      </p>

      <!-- Technologies Preview -->
      <div class="mb-6">
        <div class="flex flex-wrap gap-2">
          <span
            v-for="tech in service.technologies.slice(0, 4)"
            :key="tech"
            class="rounded-full bg-gradient-to-r from-accent/10 to-gradient-end/10 px-3 py-1 text-xs font-medium text-ternary-dark dark:text-ternary-light"
          >
            {{ tech }}
          </span>
          <span
            v-if="service.technologies.length > 4"
            class="rounded-full bg-gradient-to-r from-accent/10 to-gradient-end/10 px-3 py-1 text-xs font-medium text-ternary-dark dark:text-ternary-light"
          >
            +{{ service.technologies.length - 4 }} more
          </span>
        </div>
      </div>

      <!-- CTA Button -->
      <div class="inline-flex items-center text-accent transition-colors duration-300 group-hover:text-gradient-end">
        <span class="font-semibold">Learn More</span>
        <PhArrowRight class="ml-2 size-4 transition-transform duration-300 group-hover:translate-x-1" />
      </div>
    </div>
  </NuxtLink>
</template>

<script setup lang="ts">
import type { Service } from '~/data/services'
import { PhArrowRight } from '@phosphor-icons/vue'

interface Props {
  service: Service
}

defineProps<Props>()
</script>
